// AUTO-GENERATED by tools/codegen (pnpm gen). Do not edit. Source: apps/client/src/ui/screens/*.ts
import * as m0 from './screens/admin';
import * as m1 from './screens/blocked';
import * as m2 from './screens/boot';
import * as m3 from './screens/catch';
import * as m4 from './screens/chat';
import * as m5 from './screens/confirmRemove';
import * as m6 from './screens/confirmTidy';
import * as m7 from './screens/creator';
import * as m8 from './screens/decorate';
import * as m9 from './screens/deleteAccount';
import * as m10 from './screens/dialogue';
import * as m11 from './screens/donate';
import * as m12 from './screens/door';
import * as m13 from './screens/emotes';
import * as m14 from './screens/fishLog';
import * as m15 from './screens/foundTown';
import * as m16 from './screens/gift';
import * as m17 from './screens/hud';
import * as m18 from './screens/invite';
import * as m19 from './screens/invites';
import * as m20 from './screens/letter';
import * as m21 from './screens/loan';
import * as m22 from './screens/mailbox';
import * as m23 from './screens/menu';
import * as m24 from './screens/museum';
import * as m25 from './screens/news';
import * as m26 from './screens/pockets';
import * as m27 from './screens/report';
import * as m28 from './screens/residents';
import * as m29 from './screens/roof';
import * as m30 from './screens/sell';
import * as m31 from './screens/settings';
import * as m32 from './screens/shop';
import * as m33 from './screens/signIn';
import * as m34 from './screens/storage';
import * as m35 from './screens/title';
import * as m36 from './screens/townSettings';
import * as m37 from './screens/towns';
import * as m38 from './screens/update';
import * as m39 from './screens/villagerTalk';
import * as m40 from './screens/writer';
export const screenModules = [m0, m1, m2, m3, m4, m5, m6, m7, m8, m9, m10, m11, m12, m13, m14, m15, m16, m17, m18, m19, m20, m21, m22, m23, m24, m25, m26, m27, m28, m29, m30, m31, m32, m33, m34, m35, m36, m37, m38, m39, m40] as const;
